import * as React from 'react'
import UIMessages from 'src/utils/ui-messages'
import FindIcon from '../icons/ui/Find'
import { Input } from '@mobiscroll/react-latest'

class ProviderProductSearch extends React.Component<any, any> {
  private inputRef: any

  constructor(props: any) {
    super(props)
  }

  public render() {
    return (
      <div className='flex items-center mr3'>
        <Input
          ref={this.attachRef}
          type='text'
          value={this.props.query}
          onChange={this.props.onChange}
          placeholder={UIMessages.common.search}
          theme='ios'
          themeVariant='light'
          inputStyle='box'
          labelStyle='floating'
          className='mr1 mobiscroll-input'
        />
        <div onClick={this.onClick}>
          <FindIcon className='svg-stroke-grey3' />
        </div>
      </div>
    )
  }

  private onClick = (e: React.MouseEvent<HTMLElement>) => {
    this.inputRef.focus()
  }

  private attachRef = (elm: any) => {
    this.inputRef = elm
  }
}

export default ProviderProductSearch



// WEBPACK FOOTER //
// ./src/components/products/ProviderProductSearch.tsx